export interface Billing {
  id: string;
  rfc: string;
  name: string;
  adress: string;
  regime: string;
  action: string;
}

export enum CFDIEnumKeys {
  OTHER_CFDI = 'otherCfdiUses',
  TRANSPORT_CFDI = 'transportCfdiUses',
  TUITION_CFDI = 'tuitionCfdiUses',
  WITHOUT_TAX_EFFECTS_CFDI = 'withoutTaxEffectsCfdiUses',
  DONATIONS_CFDI = 'donationsCfdiUses',
}
